.table {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;

  a:link {
    color: #0060b8;
    text-decoration: underline;
  }

  td {
    padding: 1rem;
  }

  th {
    text-align: left;
    &.active-sort-column {
      background-color: var(--dsc-table-header-background--sorted);
    }
    &:hover {
      background-color: var(--dsc-table-header-background--hover);
    }
    &:has([role='checkbox']) {
      padding: 1rem;
    }
    > button {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 1rem;
      width: fit-content;
    }
  }

  tr {
    background-color: white;
  }

  tbody {
    td > button {
      margin-top: -9px;
      margin-bottom: -9px;
    }

    td {
      a {
        color: #0060b8;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  tfoot {
    tr:first-child {
      border-top: 2px solid #f2f2f2;
    }

    font-weight: 700;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    background-color: #d6f6ff;
    color: #000000;
  }
}
